<template>
    <b-list-group class="rkm-sidebar-list-group">
        <slot />
    </b-list-group>
</template>

<script>
// Components.
import {BListGroup} from 'bootstrap-vue'

export default {
    components: {BListGroup},
}
</script>

<style scoped>
.rkm-sidebar-list-group {
    align-items: center;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
}
</style>